import React, { useState } from 'react'
import { Link } from 'gatsby'
import Layout from '../components/Layout'
import Seo from '../components/Seo'
import { submitGrievance } from '../helper/handles'

const Grievance = () => {

	const [g_data, setG_data] = useState({
		"full_name": "",
		"message": "",
		"phone_number": ""
	})
	const [isLoading, setIsLoading] = useState(false)
	const [formMsg, setFormMsg] = useState({
		type: '',
		msg: ''
	})


	const validateAndSetNumber = e => {
		const val = e.target.value
		if (val.length < 11 && !isNaN(val)) {
			setG_data({ ...g_data, 'phone_number': val })
		}
	}

	const handleSubmit = e => {
		e.preventDefault()
		setIsLoading(true)

		submitGrievance(g_data, (res) => {
			setIsLoading(false)
			if (res?.name === 'Error') {
				setFormMsg({
					type: 'error',
					msg: 'Unable to send request. Try after sometime.'
				})

			} else {
				setFormMsg({
					type: 'success',
					msg: 'Your request has been submitted. We will review it and call you on the phone number provided.'
				})
			}
			setG_data({
				"full_name": "",
				"message": "",
				"phone_number": ""
			})
		})
	}

	return (
		<Layout>
			<Seo title={`Grievance | NAC, Dharamgarh`} />
			<header className="header">
				<div className="header__jumbotron baseWrap df jcsb fww">
					<h2 className="sec_heading">Grievance</h2>
					<ol className="breadcrumb">
						<li className="breadcrumb-item">
							<Link to="/">Home</Link>
						</li>
						<li className="breadcrumb-item active">
							<span>Grievance</span>
						</li>
					</ol>
				</div>
			</header>
			<section className="sec sec_page df">
				<div className="baseWrap">
					<div className="contentWrap h100 ma shadow df aic">
						<div className="w100">
							<h3 className="sec_heading tac" style={{ 'marginBottom': '1rem' }}>Grievance</h3>
							<form action="#!" className="form w100 ma font2" autoComplete="off" spellCheck="false" onSubmit={handleSubmit}>
								<div className="grid2">
									<div className="input_group">
										<label htmlFor="g_name">Full Name</label>
										<input type="text" name="full_name" id="g_name" className="input_control" required value={g_data.full_name} onInput={(e) => { setG_data({ ...g_data, full_name: e.target.value }) }} />
									</div>
									<div className="input_group">
										<label htmlFor="g_phone">Phone Number</label>
										<div className="input_preset">
											<span>+91</span>
											<input type="tel" name="phone_number" id="g_phone" required value={g_data.phone_number} onInput={validateAndSetNumber} />
										</div>
									</div>
								</div>
								<div className="input_group">
									<label htmlFor="g_message">Your Message</label>
									<textarea name="message" rows="4" cols="30" id="g_message" className="input_control scroll" required value={g_data.message} onInput={(e) => setG_data({ ...g_data, message: e.target.value })}></textarea>
								</div>

								<div className="input_group df jcsb aic fww" style={{ 'marginTop': '2rem' }}>
									<span className={`form_msg text ${formMsg.type}`}>{formMsg.msg}</span>

									{isLoading ? (
										<button className="btn btn_icon" disabled>
											<i className="material-icons-round">loop</i>
											<span>Submitting ...</span>
										</button>
									) : (
											<button type="submit" className="btn btn_icon right">
												<span>SUBMIT</span>
												<i className="material-icons-round">drive_file_rename_outline</i>
											</button>
										)}
								</div>
							</form>
						</div>
					</div>
				</div>
			</section>
		</Layout>
	)
}

export default Grievance
